import React from 'react';

export default function ({ children }) {
    return (
        <thead className="p-datatable-thead" data-pc-name="datatable" data-pc-section="thead">
            <tr role="row" data-pc-section="headerrow">
                 {children}
            </tr>
        </thead>
    );
}
